import fxUtils from 'lib/util'
import weixin from 'lib/weixin'
import appPlugin from 'lib/plugin'
import fxCommon from 'lib/common'

export default function (Vue) {
	appPlugin(Vue)
	Vue.prototype.$fxUtils = fxUtils
	Vue.prototype.$fxWeixin = weixin
	Vue.prototype.$fxCommon = fxCommon
}



// WEBPACK FOOTER //
// ./src/lib/appInit/index.js